import { render, staticRenderFns } from "./PolymorphicReferenceIndex.vue?vue&type=template&id=43ca95ea&"
import script from "./PolymorphicReferenceIndex.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports